const SDK = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
  PIXEL_ID: process.env.REACT_APP_PIXEL_ID,
};

export default SDK;
